import { NavbarItem } from "./types";

export const navbarItems: NavbarItem[] = [
    { id: "home", label: "Home" },
    { id: "about-us", label: "About us" },
    { id: "our-services", label: "Our services" },
    { id: "contact-us", label: "Contact us" },
];